import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseUrlService } from './base-url.service';

@Injectable()
export class ByPassWorkerService<T> implements HttpInterceptor {
  private api: string;
  private identity: string;

  constructor(private baseUrlService: BaseUrlService) {
    this.api = this.baseUrlService.getApiBaseURL();
    this.identity = this.baseUrlService.getIdentityBaseURL();
  }

  public intercept(
    req: HttpRequest<T>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (this.startsWithAPI(req.url)) {
      req = req.clone({ setHeaders: { 'ngsw-bypass': 'clear' } });
    }
    return next.handle(req);
  }

  private startsWithAPI(url: string): boolean {
    return url.startsWith(this.api) || url.startsWith(this.identity);
  }
}
